import {useMemo} from 'react';
import type {Property} from 'csstype';
import type {ResponsiveValue} from '@tempo/core';
import type {ResponsiveObject, ThemeTypings} from '@tempo/system';

export const useResponsiveBooleanDisplay = (
	responsiveBoolean: ResponsiveValue<boolean> | undefined,
	display: Property.Display = 'block',
) => {
	return useMemo(() => {
		if (typeof responsiveBoolean === 'undefined') {
			return undefined;
		}

		if (responsiveBoolean === true) {
			return display;
		}

		if (responsiveBoolean === false) {
			return 'none';
		}

		return Object.entries(responsiveBoolean).reduce<
			ResponsiveObject<Property.Display>
		>((acc, [key, value]) => {
			acc[key as ThemeTypings['breakpoints']] = value ? display : 'none';
			return acc;
		}, {});
	}, [display, responsiveBoolean]);
};
